export enum Urls {
  Account = "account",
  AccountSettings = "settings",
  DockerSettings = "docker",
  ActivateToken = "activate-token",
  Batch = "batch",
  Billing = "settings/billing",
  Clusters = "clusters",
  CoiledProPage = "go-coiled-pro",
  CoiledStaff = "staff",
  Credentials = "credentials",
  Docs = "https://docs.coiled.io",
  ForgotPassword = "password/forgot",
  GetStarted = "get-started",
  GithubInitLogin = "users/github/login",
  GithubLogin = "users/github",
  GoogleInitLogin = "users/google/login",
  GoogleLogin = "users/google",
  Infrastructure = "infrastructure",
  Login = "login",
  Notebooks = "notebooks",
  Organizations = "organizations",
  Profile = "profile",
  Pricing = "settings/billing/pricing",
  ResetPassword = "password/reset",
  RetrieveUsername = "username/forgot",
  Root = "/",
  Setup = "settings/setup",
  SignUp = "signup",
  Slack = "https://join.slack.com/t/coiled-users/shared_invite/zt-hx1fnr7k-In~Q8ui3XkQfvQon0yN5WQ",
  Software = "software",
  Team = "team",
  Usage = "usage",
  UserInfoForm = "user-info-form",
  VerifyEmailConfirm = "verify/confirm",
  VerifyEmailReSend = "verify/resend",
  VerifyEmailSent = "verify/sent",
  Workspaces = "workspaces",
}
